import React, { useState } from 'react';
import { V2BarChartOptions } from '@terragotech/page-renderer';
import { TGSelect } from '../../../views/components/formElements';
import { ChartEditSectionProps } from './common';
import { ColorPaletteChartOption, LegendPositionChartOption } from './common';

const groupModeOptions: Record<NonNullable<V2BarChartOptions['groupMode']>, string> = {
  grouped: 'Grouped',
  stacked: 'Stacked',
};
const layoutOptions: Record<NonNullable<V2BarChartOptions['layout']>, string> = {
  horizontal: 'Horizontal',
  vertical: 'Vertical',
};

export const BarChartEditSection: React.FC<ChartEditSectionProps<'bar'>> = ({
  chartOptions,
  setChartOptions,
  optionStyles,
}) => {
  const [colorPalette, setColorPalette] = useState(chartOptions?.colorPalette);
  const [legendPosition, setLegendPosition] = useState(chartOptions?.legendPosition);
  const [groupMode, setGroupMode] = useState(chartOptions?.groupMode);
  const [layout, setLayout] = useState(chartOptions?.layout);

  return (
    <>
      <ColorPaletteChartOption
        value={colorPalette}
        onChange={(value) => {
          setColorPalette(value);
          setChartOptions((o) => ({ ...o, colorPalette: value }));
        }}
        optionStyles={optionStyles}
      />
      <LegendPositionChartOption
        value={legendPosition}
        onChange={(value) => {
          setLegendPosition(value);
          setChartOptions((o) => ({ ...o, legendPosition: value }));
        }}
        optionStyles={optionStyles}
      />
      <TGSelect
        id="groupMode"
        label="Group Mode"
        value={groupModeOptions[groupMode!]}
        options={groupModeOptions}
        canShowEmpty={true}
        onChange={(value) => {
          setGroupMode(value as V2BarChartOptions['groupMode']);
          setChartOptions((o) => ({ ...o, groupMode: value as V2BarChartOptions['groupMode'] || undefined }));
        }}
        {...optionStyles}
      />
      <TGSelect
        id="layout"
        label="Layout"
        value={layoutOptions[layout!]}
        options={layoutOptions}
        canShowEmpty={true}
        onChange={(value) => {
          setLayout(value as V2BarChartOptions['layout']);
          setChartOptions((o) => ({ ...o, layout: value as V2BarChartOptions['layout'] || undefined }));
        }}
        {...optionStyles}
      />
    </>
  );
};

export default BarChartEditSection;
